// Company object model definition
/**
 * CompanyModel sample structure:
 * {
 *   companyName: 'Acme Events',
 *   email: 'info@acme.com',
 *   phoneNumber: '123-456-7890',
 *   website: 'https://acme.com',
 *   logo: File or URL,
 *   addresses: [
 *     { street: '123 Main St', city: 'Metropolis', state: 'NY', zipCode: '10001' }
 *   ],
 *   companyTypes: ['venue', 'catering'],
 *   admins: [
 *     { firstName: 'Alice', lastName: 'Smith', role: 'Owner', email: 'alice@acme.com', phone: '123-456-7890' }
 *   ],
 *   documents: {
 *     business_license: [File or URL],
 *     insurance: [File or URL],
 *     venue_intake_form: [File or URL],
 *     catering_license: [File or URL],
 *     sponsor_branding: [File or URL]
 *   }
 * }
 */
const CompanyModel = {
    // Basic Information
    companyName: '', // as "name" in Supabase
    phoneNumber: '',
    website: '',  // optional
    logo: null,   // File object or string URL
    domain: '',

    // Company Addresses
    addresses: [
        {
            street: '',
            city: '',
            state: '',
            zipCode: ''
        }
    ],

    // Company Types (e.g., ['Restaurant', 'Catering'])
    companyTypes: [],

    // Company Administrators
    admins: [
        {
            firstName: '',
            lastName: '',
            role: '',
            email: '',
            phone: ''
        }
    ],

    // Required Documents
    documents: {
        business_license: [],  // array of document URLs/paths
        insurance: [],         // array of document URLs/paths
        venue_intake_form: [], // optional
        catering_license: [],   // optional
        sponsor_branding: []    // optional
    }
};

export default CompanyModel; 